"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var enums_1 = require("../enums");

var Input_1 = __importDefault(require("../Input"));

var NumberInputContent_1 = require("./NumberInputContent");

var NumberInput = function NumberInput(_a) {
  var language = _a.language,
      _a$min = _a.min,
      min = _a$min === void 0 ? 0 : _a$min,
      max = _a.max,
      _a$precision = _a.precision,
      precision = _a$precision === void 0 ? 0 : _a$precision,
      props = __rest(_a, ["language", "min", "max", "precision"]);

  var inputValidationContent = NumberInputContent_1.NumberInputContent[language];

  var validateNumber = function validateNumber(value) {
    var error = "";
    var inputNumber = Number(value);
    var numberRegex = new RegExp("^\\d+".concat(precision !== 0 ? "(\\.\\d{0,".concat(precision, "})?") : "", "$"));

    if (value && inputNumber < min) {
      error = inputValidationContent.mustBeGreaterThan.replace("%min%", min.toString());
    } else if (value && max && inputNumber > max) {
      error = inputValidationContent.mustBeLessThan.replace("%max%", max.toString());
    } else if (value && !numberRegex.test(value)) {
      error = inputValidationContent.invalidPattern.replace("%precision%", precision.toString());
    }

    return error;
  };

  var validation = function validation(value) {
    var error = "";
    error = validateNumber(value);

    if (!error && props.validation) {
      error = props.validation(value);
    }

    return error;
  };

  var onChange = function onChange(event) {
    // Convert to number such as .5 to 0.5 and 012 to 12.
    if (event.target.value) {
      var numberString = String(event.target.value);

      if (numberString.startsWith(".") || numberString.match(/^0\d+$/) !== null) {
        var number = Number(event.target.value);

        if (!Number.isNaN(number)) {
          event.target.value = number;
        }
      }
    }

    props.onChange(event);
  };

  return (0, jsx_runtime_1.jsx)(Input_1.default, Object.assign({
    allowedCharacters: enums_1.AllowedCharacters.Numeric
  }, props, {
    min: min,
    max: max,
    validation: validation,
    inputType: "number",
    language: language,
    onChange: onChange
  }));
};

NumberInput.displayName = "NumberInput";
exports.default = NumberInput;